// Ampel-Banding für das Flexibilitäts-Screening — Wellness-Heuristik, KEINE
// klinische Norm. Siehe gait/docs/FLEX_TEST_CATALOG.md für die Cut-Werte je
// Bewegung und gait/docs/FLEX_WELLNESS_ABGRENZUNG.md für die Abgrenzung.
//
// Pattern bewusst parallel zu ../gait/bands.ts (kategoriales Band, versionierte
// Schwellen, Magnitude bleibt intern), aber NICHT von dort importiert — eigene
// Typen (FlexBand statt DeviationBand/TendencyBand) verhindern, dass klinische
// und Wellness-Sprache sich vermischen.

import type { FlexBand, FlexConfidence } from "./types";

export const FLEX_THRESHOLD_VERSION = "flex-seed-1";

/** cuts = [lowCut, highCut], ascending. value < lowCut -> EINGESCHRAENKT, etc. */
export function flexBandFromCuts(value: number, cuts: [number, number]): FlexBand {
  if (value < cuts[0]) return "EINGESCHRAENKT";
  if (value < cuts[1]) return "OK";
  return "GUT";
}

/**
 * Confidence from capture quality alone — mean landmark visibility and frame
 * count. No gait-cycle concept here (this is a held/active movement, not a
 * walking bout), so this intentionally does NOT reuse gait's
 * `deriveConfidence` (which requires a cycle count).
 */
export function deriveFlexConfidence(meanVisibility: number, frameCount: number): FlexConfidence {
  if (meanVisibility >= 0.7 && frameCount >= 45) return "high";
  if (meanVisibility >= 0.55 && frameCount >= 20) return "medium";
  return "low";
}

const CONFIDENCE_RANK: Record<FlexConfidence, number> = { low: 0, medium: 1, high: 2 };

/** Clamp a confidence value to never exceed `cap` (e.g. out-of-plane movements). */
export function capFlexConfidence(c: FlexConfidence, cap: FlexConfidence): FlexConfidence {
  return CONFIDENCE_RANK[c] <= CONFIDENCE_RANK[cap] ? c : cap;
}
